import { Outlet } from 'react-router-dom'

export const PublicLayout = () => {
    return (
        <div className="flex flex-1 flex-col " data-theme="atendimento">
            <Outlet />
        </div>
    )
}
